export const dashboardPath = "/dashboard";
